import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';

// context
import { AppProvider } from '@streamster/shared/app/app.provider';
import { SocketProvider } from '@streamster/shared/socket/socket.provider';
import { ToasterProvider } from '@streamster/shared/toaster/toaster.provider';

// componenets
import ToasterMessages from '@streamster/shared/toaster/toaster-messages';

import { queryClient } from '@streamster/shared/app/app.queryClient';
import AblyRealtime from '../components/AblyRealtime';
import GlobalModal from '../components/GlobalModal';
import StreamsterSupportChat from '../components/StreamsterSupportChat';
import { WebLayout } from '../components/WebLayout/WebLayout';
import Navigation from '../navigation/navigation';
import AuthProvider from '@streamster/shared/screens/auth/auth.provider';
import './app.styles.scss';

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />
    <ToasterProvider>
      <AppProvider>
        <AuthProvider>
          <SocketProvider>
            <WebLayout>
              <Navigation />
              <ToasterMessages />
            </WebLayout>
            <StreamsterSupportChat />
            <AblyRealtime />
            <GlobalModal />
          </SocketProvider>
        </AuthProvider>
      </AppProvider>
    </ToasterProvider>
  </QueryClientProvider>
);

export default App;
